import React, { useMemo, useCallback } from 'react';
import { useRouter } from 'next/router';
import { Button } from 'client/components/common/Button';
import { Checkbox } from 'src/client/components/recruitments/Checkbox';
import { useUrlQueryParams } from 'client/hooks/recruitment/RecruitmentList/useUrlQueryParams';
import { useRecruitmentListContext } from 'src/client/contexts/recruitments/RecruitmentList';
import { AreaTreeQuery } from 'src/client/generated';

type Props = {
  selectedRegion: string;
  areaTreeData: AreaTreeQuery | undefined;
};

export const PrefecturesList = ({ selectedRegion, areaTreeData }: Props) => {
  const {
    searchQueryParams: {
      date,
      areaIds,
      licenseIds,
      facilityFeatureIds,
      jobBenefitIds,
      sortOptionId,
      workingHourOptionIds,
      maximumWorkingHours,
      maximumDailyWage,
      minimumDailyWage,
      jobTaskIds,
      onlyRecruiting,
    },
    ui: { modeHistory },
    dispatch,
  } = useRecruitmentListContext();

  const router = useRouter();
  const { urlQueryParams } = useUrlQueryParams({
    date,
    areaIds,
    licenseIds,
    facilityFeatureIds,
    jobBenefitIds,
    sortOptionId,
    maximumDailyWage,
    minimumDailyWage,
    workingHourOptionIds,
    maximumWorkingHours,
    jobTaskIds,
    onlyRecruiting,
  });

  const lastMode = modeHistory[modeHistory.length - 2];

  const regionSelectedValue = useMemo(() => {
    return areaTreeData?.areaTree.regions.filter((o) => selectedRegion.includes(o.id)).map((o) => o.areaLList);
  }, [selectedRegion, areaTreeData]);

  const handleClickCheckbox = useCallback(
    (id: string) => {
      let newSelectedAreaIds = areaIds ? Array.from(areaIds) : [];

      if (areaIds?.includes(id)) {
        newSelectedAreaIds = newSelectedAreaIds.filter((areaId) => areaId !== id);
      } else {
        newSelectedAreaIds.push(id);
      }

      dispatch({
        type: 'changeAreaIds',
        payload: { areaIds: newSelectedAreaIds },
      });
    },
    [areaIds],
  );

  const isChecked = (id: string) => {
    return areaIds?.includes(id) || false;
  };

  const handleSearchClick = () => {
    router.push(
      {
        query: urlQueryParams,
      },
      {
        // @ts-ignore
        pathname: router.query.name,
        query: urlQueryParams,
      },
      { shallow: true },
    );
    handleClickClose();
  };

  const handleClickClose = () => {
    dispatch({
      type: 'changeDisplayMode',
      payload: { displayMode: lastMode },
    });
  };

  return (
    <>
      <div className="mx-4">
        {regionSelectedValue &&
          regionSelectedValue[0]?.map((prefecture) => (
            <div
              key={prefecture.id}
              className="w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray"
              onClick={() => handleClickCheckbox(prefecture.id)}
            >
              <Checkbox label={prefecture.name} checked={isChecked(prefecture.id)} onClick={() => {}} />
            </div>
          ))}
      </div>
      <div className="w-full fixed bottom-0 text-center">
        <div className="w-full border border-light-gray"></div>
        <Button text="決定" onClick={handleSearchClick} active={!!areaIds?.length} disabled={!areaIds?.length} />
      </div>
    </>
  );
};
